import { render, staticRenderFns } from "./CreateReceiverForm.vue?vue&type=template&id=3093f81e&"
import script from "./CreateReceiverForm.vue?vue&type=script&lang=ts&"
export * from "./CreateReceiverForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports